<app-ag-grid [gridOptions]="logGridOptions" [rowData]="logs" class="h-full"></app-ag-grid>
